/**
 * @file router main
 * @author wangzhongpeng
 */

import Vue from 'vue';
import VueRouter from 'vue-router';
import ManageHome from '@/views/manage-home';
import Finance from '@/views/finance/index';
// import Unrelevance from '@/views/finance/unrelevance';
import TaskHistory from '@/views/task/history';
import TaskList from '@/views/task/list';
import TaskAnalysis from '@/views/task/analysis';
import ErrorPage from '@/components/error-page';
import Owner from '@/views/backstage-management/wind/owner';
import Resource from '@/views/backstage-management/wind/resource';
import Tower from '@/views/backstage-management/wind/tower';
import Selection from '@/views/backstage-management/wind/selection';
import Electric from '@/views/backstage-management/wind/electric';
import Base from '@/views/backstage-management/wind/base';
import Anemometry from '@/views/backstage-management/anemometry/index';
import Email from '@/views/backstage-management/anemometry/email';
import Usercenter from '@/views/backstage-management/admin/usercenter';
import Role from '@/views/backstage-management/admin/role';
import ManaFinance from '@/views/backstage-management/finance/index';
import Economic from '@/views/backstage-management/finance/economic';
import Feedback from '@/views/backstage-management/feedback/index';
import Industry from '@/views/backstage-management/industry/index';
import Mesoscale from '@/views/backstage-management/mesoscale/index';
import TurbineList from '@/views/backstage-management/model/turbine-list';
import unitList from '@/views/backstage-management/model/unit-list';
import WindAssess from '@/views/wind-assess';

// model-data

import ModelData from '@/views/public-database/model-data/index';
import PowerCurve from '@/views/public-database/power-curve/index';
import Unit from '@/views/public-database/unit/index';

// wind-farm
import WindFarm from './wind-farm';
//typhoon
import WindData from './wind-data';

Vue.use(VueRouter);

// const router = new VueRouter({
const routes = [
  {
    name: 'root',
    path: '/',
    redirect: '/wind-farm'
  },
  {
    path: '/manage-home',
    components: {
      Home: ManageHome
    }
  },
  {
    path: '/wind-assess',
    components: {
      Home: WindAssess
    }
  },
  {
    path: '/finance',
    components: {
      Home: Finance
    }
  },
  {
    path: '/task/history',
    components: {
      Home: TaskHistory
    }
  },
  {
    path: '/task/list',
    components: {
      Home: TaskList
    }
  },
  {
    path: '/task/analysis',
    components: {
      Home: TaskAnalysis
    }
  },
  {
    name: 'public-database',
    path: '/public-database',
    redirect: '/public-database/model-data',
    components: {
      Home: () => import('@/views/public-database/index')
    },
    children: [
      {
        path: 'model-data',
        component: ModelData
      },
      {
        path: 'power-curve',
        component: PowerCurve
      },
      {
        path: 'unit',
        component: Unit
      }
    ]
  },
  {
    name: 'backstage-management',
    path: '/backstage-management',
    components: {
      Home: () => import('@/views/backstage-management/index')
    },
    children: [
      {
        path: 'finance',
        component: ManaFinance
      },
      {
        path: 'economic',
        component: Economic
      },
      {
        path: 'admin/usercenter',
        component: Usercenter
      },
      {
        path: 'admin/role',
        component: Role
      },
      {
        path: 'wind/owner',
        component: Owner
      },
      {
        path: 'wind/resource',
        component: Resource
      },
      {
        path: 'wind/tower',
        component: Tower
      },
      {
        path: 'wind/selection',
        component: Selection
      },
      {
        path: 'wind/electric',
        component: Electric
      },
      {
        path: 'wind/base',
        component: Base
      },
      {
        path: 'anemometry',
        component: Anemometry
      },
      {
        path: 'email',
        component: Email
      },
      {
        path: 'industry',
        component: Industry
      },
      {
        path: 'mesoscale',
        component: Mesoscale
      },
      {
        path: 'feedback',
        component: Feedback
      },
      {
        path: 'model/turbine',
        component: TurbineList
      },
      {
        path: 'model/unit',
        component: unitList
      }
    ]
  },
  ...WindFarm,
  ...WindData,
  {
    path: '*',
    components: {
      Home: ErrorPage
    },
    props: {
      Home: {
        type: '404'
      }
    }
  }
];
// });

//console.log(routes);

export default new VueRouter({ routes });
